import React from 'react';
import { InputNumber } from 'antd';

function CustomInputNumber({ state, setState, min, max }) {
  const handleNumericChange = (value) => {
    setState(value);
  };

  return (
    <InputNumber
      min={min}
      max={max}
      value={state}
      style={{
        marginLeft: 8,
        marginRight: 8,
      }}
      onChange={handleNumericChange}
    />
  );
}

export default CustomInputNumber;
